import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransactionsService {

  private transactionConfirmationSbj: Subject<String> = new Subject<String>();
  transactionConfirmationResponse = this.transactionConfirmationSbj.asObservable();

  constructor(private readonly http: HttpClient) { }

  getTransactionsList( itemsPerPage?: any,pageNumber?: any,merchantId?:any,voucherTitle?:any, enrichId?:any, transactionId?:any,fromDateSearch?:any,toDateSearch?:any, voucherCode?:any, transactionStatus?: string,
    sort?:any) {
    let params = new HttpParams()
    const queryParams: { [key: string]: any } = {
      page: pageNumber,
      limit: itemsPerPage,
      merchants: merchantId,
      title: voucherTitle,
      enrichId: enrichId,
      transactionId: transactionId,
      startDate: fromDateSearch,
      endDate: toDateSearch,
      voucherCode: voucherCode,
      status: transactionStatus,
      sort: sort
    };

    Object.keys(queryParams).forEach(key => {
      if (queryParams[key] !== undefined && queryParams[key] !== null) {
        params = params.set(key, queryParams[key]);
      }
    });

    return this.http.get<any>('mhvoucher/transactions',{params});
  }

  getDownloadTransactionsList( merchantId?:any,voucherTitle?:any, enrichId?:any, transactionId?:any, fromDateSearch?:any, toDateSearch?:any, voucherCode?:any, transactionStatus?: string,
    sort?:any) {
    let params = new HttpParams()
   
    const queryParams: { [key: string]: any } = {
      merchants: merchantId,
      title: voucherTitle,
      enrichId: enrichId,
      transactionId: transactionId,
      startDate: fromDateSearch,
      endDate: toDateSearch,
      voucherCode: voucherCode,
      status: transactionStatus,
      sort: sort
    };
  
    Object.keys(queryParams).forEach(key => {
      if (queryParams[key]) {
        params = params.set(key, queryParams[key]);
      }
    });
    return this.http.get<any>('mhvoucher/transactions/data/download',{params})
  }

  getTransactionDetail(transactionId:any) {
    return this.http.get<any>(`mhvoucher/transactions/${transactionId}`)
  }

  updateExpiryDate(registryId:any,data:any) {
    return this.http.patch<any>(`mhvoucher/transactions/${registryId}/expiry`,data)
  }

  updateOwner(registryId:any,data:any) {
    return this.http.patch<any>(`mhvoucher/transactions/${registryId}/owner`,data)
  }

  resetStatus(registryId:any, data:any) {
    return this.http.put<any>(`mhvoucher/transactions/${registryId}/reset`,data)
  }

  uploadTransactionFile(data:any) {
    return this.http.post<any>(`mhvoucher/transactions`,data)
  }

  deleteTransaction(registryId:any) {
    return this.http.delete<any>(`mhvoucher/transactions/${registryId}`)
  }

  cancelTransaction(registryId: any,data: any){
    return this.http.patch<any>(`mhvoucher/transactions/${registryId}/release`,data)
  }

  public setTransactionConfirmation(value:any){
    this.transactionConfirmationSbj.next(value)
  }

}
